import ajax from '../utils/ajaxHelper';

export const getClubsPaginatedApi = async (payload) => {
  try {
    return await ajax.post('community/get-clubs-paginated', payload, {
      networkParams: { showLoader: false },
    });
  } catch (error) {
    return error;
  }
};

export const getClubFiltersApi = async (payload) => {
  try {
    return await ajax.post('community/get-club-filters', payload, {
      networkParams: { showLoader: false },
    });
  } catch (error) {
    return error;
  }
};
